import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, HostListener, Input, Output } from '@angular/core';

import { EventModel, EventOption, EventOptionGroup } from '@frontend/sports/betting-offer/feature/model';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';

@Component({
    selector: 'ms-multi-builder-options',
    templateUrl: 'multi-builder-options.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class MultiBuilderOptionsComponent {
    @Input() event: EventModel;
    @Input() optionGroup: EventOptionGroup;
    @Input() trackingSource: string;
    @Input() showLogo: boolean;
    @Input() showOptionalName: boolean;
    @Input() showColumn: boolean;
    @Output() imageLoaded = new EventEmitter<boolean>();
    regularOdd: boolean;
    showParticipantImage: boolean;

    constructor(private sitecore: Sitecore) {}

    @HostBinding('class') className = 'card-option-group';

    @HostListener('click', ['$event'])
    onClick(event: Event): void {
        event.preventDefault();
    }

    logoLoaded(logoLoaded: boolean): void {
        this.imageLoaded.emit(logoLoaded);
        this.showParticipantImage = logoLoaded;
        this.regularOdd = !logoLoaded;
    }

    getResultName = (option: EventOption): string | undefined => {
        if (this.optionGroup.categoryAttribute) {
            const first = this.optionGroup.options.indexOf(option) === 0;
            const prefix = first ? this.sitecore.eventGrid.SixPack_TotalsOver : this.sitecore.eventGrid.SixPack_TotalsUnder;

            return `${prefix} ${this.optionGroup.categoryAttribute}`;
        } else if (this.showColumn) {
            return option.overridenName || '';
        } else if (option.optionAttribute) {
            return option.optionAttribute;
        } else {
            return option.overridenName || option.name;
        }
    };
}
